module.exports = __webpack_public_path__ + "img/landingImage.e12d8bf4.png";